import { keyBy } from '@src/utils/functions/utils'

import Product from '../../domains/Product'
import { INTERNAL_INVENTORY_API, SvDetails } from '../../domains/ProductPurchaseInfo'
import { InventoryResponse, getInventory } from '../inventoryService/inventory.service'

/**
 * Pure mapping from the /active-inventory response shape to the SvDetails map the buy box consumes.
 * Shared by the client fetch below and the PL payload seed (ProductService.buildProductPurchaseInfo)
 * so the two inventory sources cannot drift.
 */
export function mapInventoryToSvDetails(
  inventoryData: Record<string, InventoryResponse>,
  variants: Product['variants'],
  isB2BSelfService?: boolean,
): Record<number, SvDetails> {
  const variantsMap = keyBy(variants, 'id')

  return Object.entries(inventoryData).reduce((acc, [key, value]) => {
    const variant = variantsMap[key]
    return {
      ...acc,
      [key]: {
        id: key,
        inventoryInfoSource: INTERNAL_INVENTORY_API,
        inventoryType: value?.inventoryType,
        preOrderShippingDate: value?.tags?.preOrderShippingDate,
        price: variant?.price,
        quantityAvailable: value?.available,
        availableForCustomization: isB2BSelfService ? (value?.available ?? 0) : undefined,
        isInventoryPresentAtSFWarehouse: value?.isInventoryPresentAtSFWarehouse,
      },
    }
  }, {})
}

export async function getVariantDetailsByIdForProductVariants(
  product: Product,
  isB2BSelfService?: boolean,
): Promise<Record<number, SvDetails>> {
  if (product.variants?.length === 0) return {}
  const variantIds = product.variants?.map(variant => variant.id).join(',')
  const inventoryData: Record<string, InventoryResponse> = await getInventory({
    variantIds,
    storeResultInStorage: true,
  })

  return mapInventoryToSvDetails(inventoryData, product.variants, isB2BSelfService)
}
